export const forBusiness_graphics_process = [
	{
		icon: '✅',
		title: 'processData_title1',
		subtitle: 'processData_subtitle1',
	},
	{
		icon: '✅',
		title: 'processData_title2',
		subtitle: 'processData_subtitle2',
	},
	{
		icon: '✅',
		title: 'processData_title3',
		subtitle: 'processData_subtitle3',
	},
	{
		icon: '✅',
		title: 'processData_title4',
		subtitle: 'processData_subtitle4',
	},
];

export const processAboveList = [
	{
		text: 'processData_textAbove_text1',
	},
	{
		text: 'processData_textAbove_text2',
	},
];
